import React from 'react';

const workOrders = {
  open: [
    { id: 'TP-004821', title: 'Hot Water Cylinder Replacement', address: '14 Rata Street, Papakura, Auckland', date: '14 Jun 2026', tag: '2d left', tagColor: '#C0492A', priority: 'High' },
    { id: 'TP-004835', title: 'Blocked Drain — Kitchen & Bathroom', address: '7 Huia Road, Titirangi, Auckland', date: '15 Jun 2026', tag: '3d left', tagColor: '#9A958A', priority: 'Medium' },
    { id: 'TP-004849', title: 'Roof Leak Repair — Back of House', address: '32 Kauri Ave, Henderson, Auckland', date: '16 Jun 2026', tag: '4d left', tagColor: '#9A958A', priority: 'Medium' },
  ],
  inProgress: [
    { id: 'TP-004808', title: 'Switchboard Upgrade — 3-Phase', address: '101 Great South Road, Manurewa', date: '13 Jun 2026', tag: 'Active', tagColor: '#C08A2A', priority: 'High' },
  ],
  onHold: [
    { id: 'TP-004822', title: 'Deck Repair — Back Yard', address: '19 Tui Glen Road, Birkenhead, Auckland', date: '15 Jun 2026', tag: 'Waiting parts', tagColor: '#9A958A', priority: 'Medium' },
  ],
  closed: [
    { id: 'TP-004790', title: 'Bathroom Retile & Grouting', address: '55 Ranui Station Road, Ranui, Auckland', date: '10 Jun 2026', tag: '✓ Done', tagColor: '#5E6B39', priority: 'Medium' },
    { id: 'TP-004815', title: 'Exterior Repaint — Full House', address: '23 Waimarie Drive, St Heliers, Auckland', date: '12 Jun 2026', tag: '✓ Done', tagColor: '#5E6B39', priority: 'High' },
  ],
};

const PRIORITY = {
  High: { bg: '#F6E2DB', color: '#C0492A' },
  Medium: { bg: '#E8EBDD', color: '#5E6B39' },
};

const stats = [
  { label: 'OPEN', value: 8, color: '#2A6FB0' },
  { label: 'IN PROGRESS', value: 3, color: '#C08A2A' },
  { label: 'ON HOLD', value: 1, color: '#8A857A' },
  { label: 'CLOSED', value: 31, color: '#5E6B39' },
];

const columns = [
  { name: 'OPEN', count: 8, headBg: '#E3EDF5', headColor: '#2A6FB0', cards: workOrders.open },
  { name: 'IN PROGRESS', count: 3, headBg: '#F6EEDD', headColor: '#C08A2A', cards: workOrders.inProgress },
  { name: 'ON HOLD', count: 1, headBg: '#ECEAE3', headColor: '#7C786E', cards: workOrders.onHold },
  { name: 'CLOSED', count: 31, headBg: '#E8EBDD', headColor: '#5E6B39', cards: workOrders.closed },
];

const howItWorks = [
  { step: '01', icon: '✉️', title: 'Client sends you an email', desc: "A client emails about a job — leak, repair, install. You don't need to do anything." },
  { step: '02', icon: '⚡', title: 'Automation reads & creates it', desc: 'It extracts the job details and creates a work order on your dashboard instantly.' },
  { step: '03', icon: '🗂️', title: 'Job appears on your board', desc: 'Address, priority, due date — ready to action. No missed emails, ever.' },
  { step: '04', icon: '✅', title: 'Mark done, client notified', desc: 'Close the job and TradiePro automatically sends the client a completion confirmation.' },
];

const features = [
  { icon: '🗂️', title: 'Kanban Work Orders', desc: 'Visual board showing every job by status — Open, In Progress, On Hold, Closed.' },
  { icon: '🔔', title: 'Automated Reminders', desc: 'Never miss a deadline. Reminders fire automatically before jobs are due.' },
  { icon: '⚡', title: 'Email-to-Dashboard', desc: 'New jobs from client emails land directly in the dashboard — no manual entry.' },
  { icon: '📍', title: 'Address & Priority', desc: 'Every work order shows location, priority level, and days remaining.' },
];

const goTo = (hash) => {
  const el = document.getElementById(hash);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
  else window.location.href = `/#${hash}`;
};

const WorkCard = ({ card }) => {
  const pri = PRIORITY[card.priority] || PRIORITY.Medium;
  return (
    <div style={{ background: '#fff', border: '1px solid #EAE6DC', borderRadius: 11, padding: 13 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <span style={{ fontSize: 10, fontWeight: 700, color: '#B3AEA3', fontFamily: 'monospace' }}>{card.id}</span>
        <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 20, background: pri.bg, color: pri.color }}>{card.priority}</span>
      </div>
      <div style={{ fontSize: 13, fontWeight: 700, lineHeight: 1.3, marginBottom: 8 }}>{card.title}</div>
      <div style={{ fontSize: 11, color: '#8A857A', lineHeight: 1.4, marginBottom: 9 }}>📍 {card.address}</div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 10, color: '#9A958A' }}>
        <span>{card.date}</span>
        <span style={{ fontWeight: 700, color: card.tagColor }}>{card.tag}</span>
      </div>
    </div>
  );
};

const TradiePro = () => (
  <div className="tradiepro-page">

    {/* How it works */}
    <section style={{ maxWidth: 1150, margin: '0 auto', padding: '80px 40px 0' }}>
      <div style={{ textAlign: 'center', marginBottom: 44 }}>
        <div style={{ fontSize: 13, fontWeight: 800, letterSpacing: '0.1em', color: '#C0492A' }}>HOW IT WORKS</div>
        <h2 style={{ fontSize: 'clamp(1.6rem, 2.5vw, 2.4rem)', fontWeight: 800, letterSpacing: '-0.025em', margin: '10px 0 0', color: '#1A1A18' }}>Four steps. Zero manual entry.</h2>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 20 }}>
        {howItWorks.map(s => (
          <div key={s.step} style={{ background: '#fff', borderRadius: 20, padding: '30px 26px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
              <div style={{ width: 48, height: 48, borderRadius: 13, background: '#F6E7E1', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>{s.icon}</div>
              <span style={{ fontSize: 30, fontWeight: 800, color: '#E6E0D5' }}>{s.step}</span>
            </div>
            <h3 style={{ margin: '0 0 9px', fontSize: 18, fontWeight: 700, letterSpacing: '-0.01em', color: '#1A1A18' }}>{s.title}</h3>
            <p style={{ margin: 0, fontSize: 14, lineHeight: 1.55, color: '#5A564D' }}>{s.desc}</p>
          </div>
        ))}
      </div>
    </section>

    {/* Dashboard mockup */}
    <section style={{ maxWidth: 1150, margin: '0 auto', padding: '80px 40px 0' }}>
      <div style={{ textAlign: 'center', marginBottom: 36 }}>
        <div style={{ fontSize: 13, fontWeight: 800, letterSpacing: '0.1em', color: '#C0492A' }}>LIVE PREVIEW</div>
        <h2 style={{ fontSize: 'clamp(1.6rem, 2.5vw, 2.4rem)', fontWeight: 800, letterSpacing: '-0.025em', margin: '10px 0 0', color: '#1A1A18' }}>Your dashboard, always up to date</h2>
      </div>

      <div style={{ background: '#fff', borderRadius: 22, border: '1px solid #E6E2D8', boxShadow: '0 18px 50px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        {/* Topbar */}
        <div style={{ background: '#1A1A18', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 16, fontWeight: 800, color: '#fff' }}>⚡ TradiePro</span>
            <span style={{ fontSize: 13, color: '#8A857A' }}>Work Orders</span>
          </div>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontSize: 12, fontWeight: 600, color: '#8FA86A' }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#8FA86A', display: 'inline-block' }} />Live
          </span>
        </div>

        <div style={{ padding: '22px 24px' }}>
          {/* Search */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 9, background: '#F4F1EB', border: '1px solid #E6E2D8', borderRadius: 10, padding: '11px 14px', fontSize: 13, color: '#9A958A', marginBottom: 18 }}>
            🔍 Search work orders...
          </div>

          {/* Stats */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 22 }}>
            {stats.map(s => (
              <div key={s.label} style={{ background: '#F6F4EE', borderRadius: 12, padding: 16 }}>
                <div style={{ fontSize: 26, fontWeight: 800, color: s.color }}>{s.value}</div>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.05em', color: '#8A857A', marginTop: 2 }}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Kanban */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12 }}>
            {columns.map(col => (
              <div key={col.name}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 9, marginBottom: 10, background: col.headBg, color: col.headColor }}>
                  <span style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.06em' }}>{col.name}</span>
                  <span style={{ fontSize: 11, fontWeight: 700, background: 'rgba(255,255,255,0.5)', borderRadius: 20, padding: '1px 8px' }}>{col.count}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {col.cards.map(card => <WorkCard key={card.id} card={card} />)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* Feature highlights */}
    <section style={{ maxWidth: 1000, margin: '0 auto', padding: '80px 40px 0' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 18 }}>
        {features.map((f) => (
          <div key={f.title} style={{ background: '#fff', borderRadius: 18, padding: 26, display: 'flex', gap: 18, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
            <div style={{ flexShrink: 0, width: 48, height: 48, borderRadius: 13, background: '#EAEDE2', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>{f.icon}</div>
            <div>
              <h3 style={{ margin: '2px 0 7px', fontSize: 17, fontWeight: 700, color: '#1A1A18' }}>{f.title}</h3>
              <p style={{ margin: 0, fontSize: 14, lineHeight: 1.5, color: '#5A564D' }}>{f.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* CTA dark band */}
      <div style={{ background: '#1A1A18', borderRadius: 28, padding: '52px 40px', textAlign: 'center', marginTop: 32 }}>
        <h2 style={{ color: '#fff', fontSize: 'clamp(1.6rem, 2.5vw, 2rem)', fontWeight: 800, letterSpacing: '-0.02em', margin: 0 }}>
          Want TradiePro built for your trade?
        </h2>
        <p style={{ color: '#B5B0A5', fontSize: 18, margin: '14px 0 30px' }}>
          We'll tailor the whole flow to how your business actually runs.
        </p>
        <button onClick={() => goTo('booking')} style={{ display: 'inline-block', background: '#C0492A', color: '#fff', fontSize: 17, fontWeight: 700, padding: '16px 32px', borderRadius: 13, border: 'none', cursor: 'pointer' }}>
          Book a call →
        </button>
      </div>
    </section>

  </div>
);

export default TradiePro;
